// Services
import exerciseService from '@/app/services/main/exercise/exercise-service.js';

// Third party libraries
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Constants
import { SUCCESS_MSG } from '@/app/constants/status-constants';

export default {
	name: 'ModalEditDeleteExercise',
	components: {
		DatePicker
	},
	mixins: [
		toastMessageMixins,
		dateMixins,
		userMixins
	],
	data() {
		return this.initializeModalData();
	},
	computed: {
		isDisabled() {
			const {offLeash, onLeash, oldOffLeash, oldOnLeash} = this.exerciseDetails;
			
			return parseInt(offLeash) !== parseInt(oldOffLeash) || parseInt(onLeash) !== parseInt(oldOnLeash) ? false : true;
		}
	},
	watch: {
		isAddModalLoading(isLoading) {
			if (!isLoading) {
				this.closeModal();
			}
		},
		'exerciseDetails.offLeash': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 300 ) {
						this.exerciseDetails.offLeash = newVal;
					} else {
						this.exerciseDetails.offLeash = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		},
		'exerciseDetails.onLeash': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 300 ) {
						this.exerciseDetails.onLeash = newVal;
					} else {
						this.exerciseDetails.onLeash = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		initializeModalData() {
			return {
				exerciseDetails: {
					id:'',
					offLeash: null,
					onLeash: null,
					exerciseDate: '',
					oldOffLeash: null,
					oldOnLeash: null
				}
			}
		},
		show(content) {
			this.clearModalFields();
			
			this.exerciseDetails.id = content.id;

			this.exerciseDetails.exerciseDate = this.formatDate(content.exerciseDate);
			
			this.exerciseDetails.offLeash = content.offLeash;
			
			this.exerciseDetails.onLeash = content.onLeash;

			this.exerciseDetails.oldOffLeash = content.offLeash;
			
			this.exerciseDetails.oldOnLeash = content.onLeash;

			$(this.$refs.modalEditDeleteExercise).modal('show');
		},
		closeModal() {
			$(this.$refs.modalEditDeleteExercise).modal('hide');
		},
		clearModalFields() {
			Object.assign(this.$data, this.initializeModalData());
		},
		deleteExercise() {
			this.$swal({
				imageHeight: '30px',
				title: 'Are you sure you want to delete this exercise?',
				imageUrl: `${require('@/assets/images/_shared/dog-confirm.png')}`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true
			})
			.then(result => {
				if (result.value) {
					exerciseService.deleteExerciseById(this.exerciseDetails.id)
						.then(res => {
							if(res.status === 204){
								const { SUCCESS_DELETED_EXERCISE } = this.toastMessages.exercise();
								
								this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_DELETED_EXERCISE);
								
								this.closeModal();

								this.$emit('editDeleteExercise');
							}
						})
				}
			});
		},
		updateExercise() {
			const {exerciseDate, offLeash, onLeash, id} = this.exerciseDetails;

			const exerciseDetails = {
				exerciseDate: this.dateToISO(exerciseDate)
			};

			if (offLeash) exerciseDetails.offLeash = parseInt(offLeash);

			if (onLeash) exerciseDetails.onLeash = parseInt(onLeash);

			exerciseDetails.petId = this.getActivePet.id;

			exerciseService.updateExercise(exerciseDetails, id)
				.then(res => {
					if(res.status === 204){
						const { SUCCESS_UPDATED_EXERCISE } = this.toastMessages.exercise();
						
						this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATED_EXERCISE);
						
						this.closeModal();

						this.$emit('editDeleteExercise');
					}
				})
		},
		checkValue(type) {
			if ( type === "onLeash" ) {
				if ( this.exerciseDetails.onLeash && this.exerciseDetails.onLeash < 5 ) {
					this.exerciseDetails.onLeash = 5;
				}
			} else {
				if ( this.exerciseDetails.offLeash && this.exerciseDetails.offLeash < 5 ) {
					this.exerciseDetails.offLeash = 5;
				}
			}
		}
	}
} 